export default "__VITE_ASSET__BJLWPrco__"